<template>
  <div class="pagination">
    <div @click="changePage(0)">上一页</div>
    <div
      v-for="item in pages"
      :key='item'
      :class="{'active':currentPage==item}"
      @click="changePage(2,item)"
    >{{item}}</div>
    <div @click="changePage(1)">下一页</div>
    <div>共{{pagination.total}}条</div>
  </div>
</template>
<script>
export default {
  name: "pagination",
  props: {
    pagination: Object,
    isChange: [Number,String],
  },
  computed: {
    pages: function () {
      return Math.ceil(this.pagination.total / this.pagination.pageSize);
    },
  },
  watch: {
    isChange: function (val) {
      this.currentPage = val;
    },
  },
  created(){
    this.currentPage=this.isChange
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  methods: {
    changePage(arrow, item) {
      if (arrow == 0) {
        if (this.currentPage > 1) {
          this.currentPage--;
        } else {
          this.$message.info("已经是第一页");
          return;
        }
      } else if (arrow == 1) {
        if (this.currentPage < this.pages) {
          this.currentPage++;
        } else {
          this.$message.info("已经是最后一页");
          return;
        }
      } else if (arrow == 2) {
        this.currentPage = item;
      }
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$emit("changePage", this.currentPage);
    },
  },
};
</script>
<style lang="stylus" scoped>
.pagination {
  display: flex;
  justify-content: center;

  div {
    font-size: 12px;
    color: #707070;
    border: 1px solid #aaa;
    border-radius: 3px;
    padding: 4px 10px;
    margin-left: 10px;
    cursor: pointer;

    &:hover {
      color: #f0cd48;
      border-color: #f0cd48;
    }
  }

  .active {
    color: #333;
    border-color: #f0cd48;
    background: #f0cd48;

    &:hover {
      color: #fff;
    }
  }
}
</style>